<template>
  <div class="msg-center">
    <pageHeader title="消息中心" />

    <div class="container">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无更多数据"
        @load="onLoad"
      >
        <div class="msg-item" v-for="item in msgList" :key="item.id">
          <div class="item-title">
            <img src="@/assets/images/cell6.png" alt="" />
            <h1>{{item.title}}</h1>
          </div>
          <div class="msg-info">
            <p>
              {{item.content}}
            </p>
            <span>{{item.createTime}}</span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      msgList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters(["uuid", "userInfo"]),
  },
  methods: {

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.getMsgList();
      
      this.msgList = [...this.msgList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },
    /**
     * 获取消息列表
     */
    async getMsgList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/message/getMessageList.htm",
          "post",
          {
            uuid: this.uuid,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.msg-center {
  .container {
    padding: 0 20px 30px 20px;
  }

  .msg-item {
    width: 710px;
    background: #f8f8f8;
    border-radius: 8px;
    margin-top: 30px;

    .item-title {
      display: flex;
      align-items: center;
      padding: 25px 14px 0 14px;

      img {
        width: 36px;
        height: 36px;
        margin-right: 10px;
      }
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 30px;
        color: #ff7a3e;
        line-height: 42px;
      }
    }
    .msg-info {
      padding: 20px 20px 20px 60px;

      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #212121;
        line-height: 33px;
        margin-bottom: 20px;
      }
      span {
        display: block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #bbbbbb;
        line-height: 33px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/msgCenter/index.vue